import React from 'react';
import BaseIntegration from 'screens/Integrations/components/BaseIntegration';
import { INTEGRATIONS } from 'screens/Integrations/helpers/constants';
import { mccain as mccainProgressBarSteps } from '../../../helpers/progressBarSteps';
import StepSelector from '../StepSelector';

export const PROPERTIES_SELECTION_STEP = 3;

const BaseMccainIntegration = () => {
  return (
    <BaseIntegration
      integrationType={INTEGRATIONS.mccain}
      progressBarSteps={mccainProgressBarSteps}
      selectPropertiesStep={PROPERTIES_SELECTION_STEP}
      StepSelector={StepSelector}
    />
  );
};

export default BaseMccainIntegration;
